// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.folder-tree-item[data-v-5d0514a5] {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\n}\n.folder-tree-item.selected[data-v-5d0514a5] {\r\n  background-color: #efefef;\n}\n.material-symbols-outlined[data-v-5d0514a5] {\r\n  font-size: 18px;\r\n  margin-right: 8px;\r\n  font-variation-settings: 'wght' 300;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
